// @ts-nocheck
import React, { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import ListRows from 'components/common/ListRows';
import RectangleRow from 'components/pages/home/RectangleRow';

import Ref from 'models/propTypes/ref';
import focusManager from 'support/focus/FocusManager';
import CircleGrid from '../home/CircleGrid';
import styles from '../home/InteriorRows.module.scss';

const LandingPageRows = ({
  focusId: focusIdProp,
  renderBeforeFirst,
  renderAfterLast,
  onInteriorRowsFocusIndexChanged,
  rowsRef,
  pageName,
}) => {
  const [focusId, setFocusId] = useState(focusIdProp);

  useEffect(() => {
    if (focusIdProp) {
      setFocusId(focusIdProp);
    } else {
      setFocusId(focusManager.getNewUniqueId());
    }
  }, [focusIdProp]);
  const sportsData = useSelector(state => state.kitchenSink.data.allsports);
  const showsData = useSelector(state => state.kitchenSink.data.shows);

  let pageData = [];
  if (pageName === 'all-leagues') {
    pageData = sportsData;
  } else if (pageName === 'all-shows') {
    pageData = showsData;
  }
  const rows = pageData;

  const onListRowsFocusIndexChanged = useCallback(
    index => {
      onInteriorRowsFocusIndexChanged(index);
    },
    [onInteriorRowsFocusIndexChanged],
  );
  const shouldSnapRowToTop = useCallback(() => true, []);
  const onEndOfNavigationOverride = index => {
    if (index === 0) {
      focusManager.setCurrentFocus('left-nav-focusable-content');
    }
  };

  const renderRow = useCallback(
    (row, rowIndex) => {
      if (!row.data?.length) return null;

      let focusIdPrefix;
      if (rowIndex === 0) {
        focusIdPrefix = 'firstrow-';
      } else if (rowIndex === rows.length - 1) {
        focusIdPrefix = 'lastrow-';
      }

      const getHomeRow = () => {
        return (
          <RectangleRow
            className={styles.row}
            focusIdPrefix={focusIdPrefix}
            displayTitle
            title={row.title}
            row={row}
            titleClassName={styles.rectangleRowTitle}
            rowClassName={classNames(styles.row, styles.inverseMargin)}
            rowPos={rowIndex + 1}
            onEndOfNavigationOverride={onEndOfNavigationOverride}
          />
        );
      };

      if (rowIndex === 0) {
        return (
          <div className={styles.firstRow}>
            <div className="flex-grow-1" />
            <div className={styles.beforeFirst}>{renderBeforeFirst()}</div>
            {getHomeRow()}
            {rows.length === 1 && renderAfterLast()}
          </div>
        );
      }

      if (rowIndex === rows.length - 1) {
        return (
          <React.Fragment>
            {getHomeRow()}
            {renderAfterLast()}
          </React.Fragment>
        );
      }

      return getHomeRow();
    },
    [renderAfterLast, renderBeforeFirst, rows.length],
  );

  if (pageName === 'all-shows') {
    return (
      <React.Fragment>
        <CircleGrid
          className={classNames(styles.padding)}
          focusId={focusId}
          numCols={6}
          data={rows || []}
          prevBuffer={0}
          nextBuffer={rows.length}
        />
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <ListRows
        ref={rowsRef}
        focusId={focusId}
        className={styles.listRows}
        data={rows || []}
        renderItem={renderRow}
        buffer={3}
        restorationId={`${focusId}`}
        onListRowsFocusIndexChanged={onListRowsFocusIndexChanged}
        shouldSnapRowToTop={shouldSnapRowToTop}
      />
    </React.Fragment>
  );
};

LandingPageRows.propTypes = {
  onInteriorRowsFocusIndexChanged: PropTypes.func,
  focusId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  renderBeforeFirst: PropTypes.func,
  renderAfterLast: PropTypes.func,
  rowsRef: Ref,
  pageName: PropTypes.string,
};

LandingPageRows.defaultProps = {
  onInteriorRowsFocusIndexChanged: () => {},
  focusId: null,
  renderBeforeFirst: () => null,
  renderAfterLast: () => null,
  rowsRef: null,
  pageName: null,
};

export default React.forwardRef((props, ref) => (
  <LandingPageRows {...props} rowsRef={ref} />
));
